import * as React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import styled from "styled-components"
import Card from "../components/Card/Card"
import ItemContainer from "../components/Item/ItemContainer"
import Metadata from "../components/Metadata/Metadata"
import NewsCenterController from "../controllers/NewsCenterController"
import { ArticleCollection, FeaturedArticle, News } from "../../types"
import PageLoader from "../components/Loader/PageLoader"
import { useSelector } from "react-redux"
import { AppState } from "../store"
import MobilityHelper from "../../helpers/MobilityHelper"
import { newsLink } from "../helpers/NavigationHelper"
import { Helmet } from "react-helmet"
import NewsItem from "../../widget/components/Messenger/News/NewsItem"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
`

const FeaturedArticlesTitle = styled.div`
  color: #1a1a1a;
  line-height: 40px;
  font-weight: 700;
  font-size: 22px;
  padding-top: 8px;
  padding-bottom: 16px;
  padding-left: 12px;
  padding-right: 12px;
  margin-bottom: 4px;
`

const FeaturedArticles = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 24px;

  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: 16px;
    grid-template-columns: none;
    grid-gap: 0;
  }
`

const CollectionItems = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 24px;

  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    grid-gap: 0;
    gap: 16px;
  }
`

const CollectionItem = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 24px;
  background-color: white;
  border-radius: 8px;
  text-decoration: none;
  color: black;
  padding: 16px 24px;
  gap: 16px;
  border: 1px solid rgb(230, 230, 230);
  transition: all 0.15s linear;

  &:hover {
    border: 1px solid hsla(0, 0%, 0%, 0.6);
  }
`

const CollectionItemIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(244, 243, 237);
  width: 60px;
  height: 60px;
  min-width: 60px;
  min-height: 60px;
  border-radius: 8px;

  img {
    width: 28px;
    min-width: 28px;
    height: 28px;
    min-height: 28px;
    object-fit: cover;
  }
`

const CollectionItemContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const CollectionItemTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: black;
  margin-bottom: 2px;
  line-height: 24px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`

interface IState {
  news: News[]
  didInitialLoad: boolean
}

const Overview = () => {
  const { currentLocale, newsCenter } = useSelector((state: AppState) => state.newsCenter)

  const { t } = useTranslation()
  const [state, setState] = React.useState<IState>({
    news: [],
    didInitialLoad: false
  })

  const { news, didInitialLoad } = state

  const fetchNews = async () => {
    try {
      const { news } = await NewsCenterController.getOverview(newsCenter.id)

      setState({
        didInitialLoad: true,
        news: news,
      })
    } catch (ex) {
      console.error(ex)
    }
  }

  React.useEffect(() => {
    fetchNews().catch(console.error)
  }, [])

  if (!didInitialLoad) {
    return <PageLoader />
  }

  const title = `${newsCenter.name} - ${t('Overview::News')}`
  const localeNews = news.filter(newsItem => Boolean(MobilityHelper.getTranslation(currentLocale, newsItem.translations, 'title')))

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={title} />
      </Helmet>

      <Container>
        {localeNews.map((news) => {
          return (
            <NewsItem
              locale={currentLocale}
              news={news}
            />
          )
        })}
      </Container>
    </>
  )
}

export default Overview